module.exports = __webpack_public_path__ + "static/media/transfer-out.d910ad74.png";